import { render, staticRenderFns } from "./shop-card.vue?vue&type=template&id=0d42e800&scoped=true&"
import script from "./shop-card.vue?vue&type=script&lang=js&"
export * from "./shop-card.vue?vue&type=script&lang=js&"
import style0 from "./shop-card.vue?vue&type=style&index=0&id=0d42e800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42e800",
  null
  
)

export default component.exports